<template>
  <div
    style="position:relative;height:100%;"
  >
    <transition name="fade-up" mode="out-in">
      <div v-if="loadingHomePage" class="full-page-preloader" key="preloader">
        <v-progress-circular indeterminate :size="70" :width="7" color="primary"></v-progress-circular>
        <div class="preloader-text">Loading your account...</div>
      </div>
      <div
        v-else
        key="content"
        class="standard-content"
        :class="{ 'mobile-content': $vuetify.breakpoint.xs}"
      >
        <v-layout
        wrap
      >
        <v-flex
          xs12
          sm12
          md12
          lg12
          style="order: 0;"
        >
          <v-card
            elevation="0"
          >
            <!-- Background Refresh Progress Bar -->
            <v-progress-linear
              v-if="refreshingHomePage"
              indeterminate
              height="4"
              color="primary"
              style="position: absolute; top: 0; left: 0; right: 0; margin: 0; z-index: 10;"
            />
            <v-toolbar
              flat
              class="primary-color home-toolbar"
              :class="{ 'mobile': $vuetify.breakpoint.xs}"
            >
              <h3
                style="color:white;text-overflow:ellipsis;max-width: 80%;overflow:hidden;white-space: nowrap;"
              >
                <span class="legalFoot" />
              </h3>
              <v-spacer />
              <v-img
                :src="icon"
                style="max-height: 50px;max-width: 50px; width: auto;"
              />
            </v-toolbar>
            <div
              v-if="!isMobileApp() && isMobile && getDomainInfo.app.app_package != null && !hideAppBanner"
              style="display:flex;align-items: center;justify-content: center;background: rgb(69, 90, 100);color: white;padding: 10px;flex-wrap: wrap;"
            >
              <div
                style="max-width: 60%;text-wrap:wrap;font-size: 14px;font-weight: 500;"
              >
                Download the <span class="legalFoot"/> app today!
              </div>
              <v-img
                :src="appstoreIconURL"
                max-width="150px"
                @click="redirectToAppstore"
                style="margin-right: 2vw; margin-left: 2vw;"
              />
              <v-icon
                style="margin-left: 10px;"
                small
                @click="hideAppBanner = true"
              >
                mdi-close
              </v-icon>
            </div>
            <v-layout
              row
              wrap
            >
              <v-flex
                xs12
                sm12
                md6
              >
                <v-card-text>
                  <h3>{{clientSettings.first_name || ''}} {{clientSettings.last_name || ''}}</h3>
                  {{clientSettings.cuid || ''}}
                </v-card-text>
              </v-flex>
              <v-flex
                xs12
                sm12
                md6
              >
                <v-card-text>
                  <div>
                    <v-icon
                      left
                      size="18"
                      color="black"
                    >
                      mdi-phone-in-talk
                    </v-icon>
                    Contact <span class="legalFoot" />
                  </div>
                  <div
                    style="padding-left: 38px;"
                  >
                    <div
                      v-if="support_phone"
                    >
                      <b>Phone:</b> {{support_phone}}
                    </div>
                    <div
                      v-if="support_email"
                    >
                      <b>Email:</b> {{support_email}}
                    </div>
                    <div
                      v-if="!support_email && !support_phone"
                    >
                      <i>No contact information provided.</i>
                    </div>
                  </div>
                </v-card-text>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
        <v-flex
          style="flex-grow: 1;overflow-y: visible;order:1;overflow-x:visible;"
          :class="{'mobile-primary': $vuetify.breakpoint.smAndDown}"
          xs12 sm12 md12 lg6
        >
          <v-layout
            row
            wrap
          >
            <v-flex
              :class="{'flex-card': !$vuetify.breakpoint.xs}"
              style="padding-top: 15px;flex-grow: 1;overflow-y: hidden;"
              xs12
            >
              <v-card
                v-if="getDomainInfo.info.info_enabled"
                style="margin-bottom: 15px;"
              >
                <v-card-text
                  style="max-height: 30vh;overflow-y: auto;"
                >
                  <div
                    v-html="getDomainInfo.info.info"
                  />
                </v-card-text>
              </v-card>
              <v-card>
                <v-toolbar
                  style="position:relative;border-bottom: 1px solid rgba(0,0,0,0.1);"
                  flat
                  color="white"
                >
                  <span class="home-card-title">
                    My Cases
                  </span>
                  <v-spacer />
                  <v-icon
                    large
                  >
                    mdi-briefcase
                  </v-icon>
                </v-toolbar>
                <div
                  v-if="cases.length > 0"
                >
                  <v-list
                    two-line
                  >
                    <v-list-tile
                      class="form-card"
                      v-for="cs in cases"
                      :key="cs.id"
                      @click="$router.push({ name: 'Forms', params: { id: cs.id } })"
                    >
                      <v-list-tile-content>
                        <div
                            style="display:flex;align-items: center;"
                        >
                            <div>
                                <img
                                    :src="getIconPath(cs.case_type.id)"
                                    style="aspect-ratio: 1/1; max-height: 65px;margin: 10px;"
                                />
                            </div>
                            <div
                                style="flex-grow: 1;"
                            >
                                <div
                                    style="font-size: 16px;font-weight: bold;"
                                >
                                    {{cs.case_type.name}}
                                </div>
                                <div>
                                  <span
                                      v-if="cs.case_number"
                                      style="font-weight: bold;"
                                  >
                                      {{cs.case_number}}
                                  </span>
                                  <span
                                      v-if="cs.case_title"
                                      style="font-style: italic;"
                                  >
                                      ({{cs.case_title}})
                                  </span>
                                </div>
                            </div>
                        </div>
                      </v-list-tile-content>
                      <v-list-tile-action
                        v-if="!$vuetify.breakpoint.xs"
                      >
                        <v-btn
                          color="primary"
                          small
                        >
                          Open
                        </v-btn>
                      </v-list-tile-action>
                    </v-list-tile>
                  </v-list>
                </div>
                <div
                  v-else
                  style="position:relative;padding: 25px;text-align:center"
                >
                  <v-icon
                    size="36"
                  >
                    mdi-tray
                  </v-icon>
                  <br />
                  <span>You have no open cases</span>
                </div>
                <v-card-actions
                  style="background: #E0E0E0;"
                >
                  <v-spacer />
                  <v-btn
                    small
                    flat
                    :to="{'name': 'Cases'}"
                  >
                    All Cases&nbsp;
                    <v-icon
                      small
                    >
                      mdi-chevron-right
                    </v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
              <v-card
                style="margin-top: 15px;margin-bottom: 50px;"
              >
                <v-toolbar
                  style="position:relative;border-bottom: 1px solid rgba(0,0,0,0.1);"
                  flat
                  color="white"
                >
                  <span class="home-card-title">
                    Recently Uploaded Files
                  </span>
                  <v-spacer />
                  <v-badge
                    :value="unreadFiles > 0"
                    style="margin-right: 25px;"
                  >
                    <template v-slot:badge>
                      <span>{{unreadFiles}}</span>
                    </template>
                  </v-badge>
                  <v-icon
                    large
                  >
                    mdi-file-cloud
                  </v-icon>
                </v-toolbar>
                <div
                  v-if="unreadFiles > 0"
                >
                  <v-list
                    two-line
                  >
                    <v-list-tile
                      v-for="file in recentUnreadFiles"
                      :key="file.id"
                    >
                      <v-list-tile-content>
                        <v-list-tile-title>
                          {{file.name}}
                        </v-list-tile-title>
                        <v-list-tile-sub-title>
                          {{convertToCalRef(file.created_at)}}
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-btn
                          small
                          fab
                          flat
                          color="primary"
                          style="opacity: 0.8;"
                          @click="getFile(file.id, file.name)"
                        >
                          <v-icon>
                            mdi-download-circle
                          </v-icon>
                        </v-btn>
                      </v-list-tile-action>
                    </v-list-tile>
                  </v-list>
                </div>
                <div
                  v-else
                  style="position:relative;padding: 25px;text-align:center"
                >
                  <v-icon
                    size="36"
                  >
                    mdi-tray
                  </v-icon>
                  <br />
                  <span>No Recent Files</span>
                </div>
                <v-card-actions
                  style="background: #E0E0E0;"
                >
                  <v-spacer />
                  <v-btn
                    small
                    flat
                    :to="{'name': 'Files'}"
                  >
                    All Files&nbsp;
                    <v-icon
                      small
                    >
                      mdi-chevron-right
                    </v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex
          v-if="newsArticles.length > 0"
          :class="{'flex-card': !$vuetify.breakpoint.xs, 'mobile-news': ($vuetify.breakpoint.smAndDown && !expandMobileNews), 'mobile-news-expanded': ($vuetify.breakpoint.smAndDown && expandMobileNews)}"
          style="padding-top: 15px;order: 2;"
          xs12
          sm12
          md12
          lg6
        >
          <v-card>
            <v-toolbar
              v-if="!$vuetify.breakpoint.smAndDown"
              flat
              dense
            >
              <span class="home-card-title" style="font-size: 14px !important;">
                Latest News
              </span>
              <v-spacer />
              <v-icon>
                mdi-newspaper
              </v-icon>
            </v-toolbar>
            <v-card-text
              class="news-feed"
              style="max-height: calc(100vh - 159px - 25px - 48px);overflow-y:scroll;"
            >
              <div
                v-for="article in newsArticles"
                class="news-article"
                :key="article.id"
                style="margin-bottom: 20px;"
              >
                <NewsCard
                  :article="article"
                />
              </div>
              <div
                v-if="moreNews && (!$vuetify.breakpoint.smAndDown || $vuetify.breakpoint.smAndDown && expandMobileNews)"
                style="text-align: center;"
              >
                <v-btn
                  @click="newsPage = newsPage + 1;fetchNews()"
                  :loading="newsLoading"
                  :disable="newsLoading"
                  depressed
                  color="primary"
                  dark
                >
                  Load More Articles
                </v-btn>
              </div>
            </v-card-text>
            <v-card-actions
              v-if="$vuetify.breakpoint.smAndDown"
            >
              <v-spacer />
              <v-btn
                small
                flat
                @click="expandMobileNews = !expandMobileNews"
              >
                {{ expandMobileNews ? 'Less News' : 'More News' }}
                <v-icon
                  small
                >
                  mdi-chevron-right
                </v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </div>
    </transition>

    <v-dialog
      v-model="showPrivacyConsent"
      width="850"
      persistent
      transition="dialog-bottom-transition"
      scrollable
      :fullscreen="$vuetify.breakpoint.xs"
    >
      <v-card>
        <v-card-text
          style="max-width: 800px;margin:auto;"
        >
          <div
            style="font-size: 36px;font-weight:100;"
          >
            Our Privacy Policy
          </div>
          <div
            style="font-size: 16px;"
          >
            <div style="margin-bottom: 15px;">
              <v-avatar color="primary" style="margin-right: 15px;float:left;">
                <v-icon dark>mdi-domain</v-icon>
              </v-avatar>
              <span class="legalFoot" /> utilizes this service to collect information about You. Data you provide is subject to this organization's own Privacy Policy.
            </div>
            <div style="margin-bottom: 15px;">
              <v-avatar color="primary" style="margin-right: 15px;float:left;">
                <v-icon dark>mdi-currency-usd-off</v-icon>
              </v-avatar>
              As a data processor, we do not monetize your Data. We do not sell, share, or otherwise distribute your data to unauthorized third parties, with limited exceptions.
            </div>
            <div style="margin-bottom: 15px;">
              <v-avatar color="primary" style="margin-right: 15px;float:left;">
                <v-icon dark>mdi-cookie</v-icon>
              </v-avatar>
              Our services use Cookies, or unique identifiers stored in your browser, to keep you logged in. {{ app_name }} does not use trackers, or cookies designed to track you outside of our services.
            </div>
            <div style="margin-bottom: 15px;">
              <v-avatar color="primary" style="margin-right: 15px;float:left;">
                <v-icon dark>mdi-shield-lock</v-icon>
              </v-avatar>
              Your data is transmitted using Secure Socket Layer (SSL) Technology to encrypt your data to and from {{ app_name }}
            </div>
            <div style="margin-bottom: 15px;">
              <v-avatar color="primary" style="margin-right: 15px;float:left;">
                <v-icon dark>mdi-api</v-icon>
              </v-avatar>
              Our services may use third party APIs to improve your experience. Use of these features is subject to the applicable API's Privacy Policy, a link to which is available in our full Privacy Policy.
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            @click="$emit('showPrivacyPolicy')"
            flat
          >
            View Privacy Policy
          </v-btn>
          <v-btn
            color="primary"
            @click="privacyConsent()"
          >
            Continue
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showTutorial"
      width="500"
      persistent
      fullscreen
      transition="slide-x-transition"
      scrollable
    >
      <v-card>
        <v-toolbar
          dense
          dark
          flat
        >
          <v-btn
            fab
            small
            flat
            style="margin-right: 10px;"
          >
            <v-icon
              size="36"
            >
              mdi-account-child-circle
            </v-icon>
          </v-btn>
          Welcome to {{ app_name }}
        </v-toolbar>
        <v-card-text
          style="max-width: 800px;margin:auto;overflow-y: auto;"
        >
          <div
            style="font-size: 36px;font-weight:100;"
          ><br />
            Welcome to {{ app_name }}, {{clientSettings.first_name}}
          </div>
          <div
            v-if="getDomainInfo && getDomainInfo.info && getDomainInfo.info.welcome_modal"
          >
            <div
              style="font-size: 16px;"
              v-html="getDomainInfo.info.welcome_modal"
            />
          </div>
          <div
            v-else
            style="font-size: 16px;"
          >
            A {{ app_name }} account has been created for you by <span class="legalFoot" />. {{ app_name }} allows you to complete forms online, upload files, and send messages.<br /><br />
            <v-carousel hide-controls>
              <v-carousel-item>
                <div class="tutorialCard" style="position: relative;height: 100%;">
                  <img class="tutImg" src="/assets/tutorial/intro.png" style="max-width: 100%;max-height: 90%;margin:auto;"/>
                  <div class="tutLower" style="position: absolute;bottom:0;left:0;right:0;background: #1976d2;color: white;padding: 15px;padding-bottom: 65px;min-height: 100px;">
                    <div class="tutHead" style="font-weight: bold;font-size: 16px;">Get Started</div>
                    <div class="tutBody" style="font-weight: 500;font-size: 12px;">The Home tab shows you your messages, recently uploaded files, and any outstanding forms you need to complete.</div>
                  </div>
                </div>
              </v-carousel-item>
              <v-carousel-item>
                <div class="tutorialCard" style="position: relative;height: 100%;">
                  <img class="tutImg" src="/assets/tutorial/forms.png" style="max-width: 100%;max-height: 90%;margin:auto;"/>
                  <div class="tutLower" style="position: absolute;bottom:0;left:0;right:0;background: #1976d2;color: white;padding: 15px;padding-bottom: 65px;min-height: 100px;">
                    <div class="tutHead" style="font-weight: bold;font-size: 16px;">Your Forms</div>
                    <div class="tutBody" style="font-weight: 500;font-size: 12px;">View all forms in your {{ app_name }} account from the "Your Forms" tab.</div>
                  </div>
                </div>
              </v-carousel-item>
              <v-carousel-item>
                <div class="tutorialCard" style="position: relative;height: 100%;">
                  <img class="tutImg" src="/assets/tutorial/files.png" style="max-width: 100%;max-height: 90%;margin:auto;"/>
                  <div class="tutLower" style="position: absolute;bottom:0;left:0;right:0;background: #1976d2;color: white;padding: 15px;padding-bottom: 65px;min-height: 100px;">
                    <div class="tutHead" style="font-weight: bold;font-size: 16px;">Your Files</div>
                    <div class="tutBody" style="font-weight: 500;font-size: 12px;">Upload Files from the "Your Files" tab, or download files that <span class="legalFoot" /> have sent for your review.</div>
                  </div>
                </div>
              </v-carousel-item>
            </v-carousel>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            @click="ackTutorial()"
          >
            Continue
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="downloading"
      width="300"
      persistent
    >
      <v-card>
        <v-card-text class="text-xs-center px-4 py-3">
          <span>
            Just a moment...
          </span>
          <v-progress-linear
            indeterminate
            query
          />
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar
        v-model="showNotice"
        :timeout="5000"
        bottom
    >
        {{ noticeText }}
        <v-btn color="pink" flat @click="showNotice = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import api from '@/api'
import NewsCard from '../../NewsCard.vue';
import { mapState, mapMutations } from 'vuex';

export default {
    name: 'Home',
    props: ['logo', 'icon', 'support_phone', 'support_email', 'tutorial'],
    components: {
      NewsCard
    },
    data () {
      return {
        showPrivacyConsent: false,
        showTutorial: false,
        tutorial_step: 0,
        cases: [],
        clientSettings: {},
        clientFiles: [],
        messages: [],
        downloading: false,
        loadingHomePage: false,
        refreshingHomePage: false,
        newsArticles: [],
        newsPage: 1,
        expandMobileNews: false,
        moreNews: false,
        newsLoading: false,
        hideAppBanner: false,
        showNotice: false,
        noticeText: ''
      }
    },
    created () {
      this.loadSettings()
      if (this.tutorial == true) {
        this.ackTutorial()
      }
      this.fetchHomePage()
      if (this.$route.query.notice) {
          this.noticeText = this.$route.query.notice
          this.showNotice = true
          this.$router.replace({'query': null})
      }
    },
    computed: {
      recentMessage () {
        var fromMessages = this.messages.filter(message => message.type == 'Message to Client')
        return fromMessages[fromMessages.length - 1]
      },
      recentUnreadFiles () {
        var files = this.clientFiles.filter((item) => {
          if (!item.created_by_name.startsWith('[Contact]') && !item.read) {
            return item
          }
        })
        if (files.length > 0) {
          return files.splice(0,4)
        } else {
          return []
        }
      },
      unreadFiles () {
        var count = 0
        this.clientFiles.forEach((item) => {
          if (!item.created_by_name.startsWith('[Contact]') && !item.read) {
            count++
          }
        })
        return count
      },
      appstoreIconURL () {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera
        if (/android/i.test(userAgent)){
          return "/assets/play.png"
        }
        if (/iPad|iPhone|iPod/.test(userAgent)){
          return "/assets/apple.svg"
        }
      },
      ...mapState('userform', ['cachedHomePageData']),
      isMobile () {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera
        if( this.$vuetify.breakpoint.xs && (/android/i.test(userAgent) || /iPad|iPhone|iPod/.test(userAgent))){
          return true
        }
        return false
      }
    },
    methods: {
      fetchNews () {
        if (!this.newsLoading) {
          this.newsLoading = true
          api.news.news.list({pageNum: this.newsPage})
            .then((data) => {
              if (data.next_page)
                this.moreNews = true
              else
                this.moreNews = false
              this.newsArticles = this.newsArticles.concat(data.results)
            })
            .finally(() => {
              this.newsLoading = false
            })
        }
      },
      getUserAgent() {
        return navigator.userAgent;
      },
      getWindow() {
        var str = ""
        for (var prop in window)
          str += `${prop}\n`
        return str
      },
      privacyConsent () {
        var nowDate = new Date()
        this.clientSettings.privacy_policy_date = nowDate.toISOString().split('T')[0]
        api.userform.contactSettings.save(this.clientSettings)
          .then(response => {
            this.clientSettings = response
            this.showPrivacyConsent = false
          })
        this.showPrivacyConsent = false
        if (!this.clientSettings.tutorial_date) {
          this.showTutorial = false
        }
      },
      getFile (id, name) {
        this.downloading = true
        api.userform.contactFiles.download(id)
          .then(response => {
            let blob = new Blob([response.data])
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = name
            link.click()
            this.downloading = false
          })
      },
      ackTutorial () {
        var nowDate = new Date()
        this.clientSettings.tutorial_date = nowDate.toISOString().split('T')[0]
        api.userform.contactSettings.save(this.clientSettings)
          .then(response => {
            this.clientSettings = response
            this.showTutorial = false
          })
      },
      loadSettings () {
        this.loading = true
        api.userform.contactSettings.get()
          .then(data => {
            this.clientSettings = data
            if (!this.clientSettings.privacy_policy_date) {
                this.showPrivacyConsent = true
            } else if (!this.clientSettings.tutorial_date) {
              this.showTutorial = false
            }
          })
      },
      fetchFiles () {
        api.userform.contactFiles.getFiles()
          .then(response => {
            this.clientFiles = response
            this.fetchMessages()
          })
      },
      fetchMessages () {
        this.loading = true
        api.users.client_messages.get({ pageNum: this.page, count: 25, ordering: '-sent_at' })
          .then(data => {
            data.results.forEach((message) => {
              message.expand = false
              this.messages.unshift(message)
            })
            this.loading = false
          })
      },
      getIconPath (id) {
        return api.cases.casetype.icon(id)
      },
      redirectToAppstore () {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera
        if (/android/i.test(userAgent)){
          window.location.href = this.getDomainInfo.app.android
        }
        if (/iPad|iPhone|iPod/.test(userAgent)){
          window.location.href = this.getDomainInfo.app.ios
        }
      },
      ...mapMutations('userform', ['setCachedHomePageData']),
      fetchHomePage() {
        if (this.cachedHomePageData) {
          // Use cached data immediately
          this.clientFiles = this.cachedHomePageData.contact_files;
          this.cases = this.cachedHomePageData.cases;
          this.newsArticles = this.cachedHomePageData.articles;
          this.loadingHomePage = false;
          this.refreshingHomePage = true; 
        } else {
          this.loadingHomePage = true;
          this.refreshingHomePage = false;
        }

        api.userform.homePage.getClientHomePage()
          .then(data => {
            this.clientFiles = data.contact_files
            this.cases = data.cases
            
            // Re-assign instead of concat if we are refreshing to prevent duplicate news articles
            if (this.refreshingHomePage) {
               this.newsArticles = data.articles;
            } else {
               this.newsArticles = this.newsArticles.concat(data.articles);
            }
            
            // Cache the newly fetched data
            this.setCachedHomePageData(data);
          })
          .finally(() => {
            this.loadingHomePage = false
            this.refreshingHomePage = false
          })
      }
    }
}
</script>

<style scoped>

    .home-toolbar.mobile {
      padding-top: var(--mobile-padding-top, initial);
    }

    .standard-content {
        max-height: calc(100vh);
        height:100%;
        overflow-y:auto;
        position: relative;
    }

    .standard-content .layout {
      max-height: 100vh;
    }

    .mobile-content {
        max-height: calc(100vh - 56px - var(--mobile-padding-bottom, 0px)) !important;
        position: relative;
    }

    .mobile-content .news-article {
      margin-bottom: unset !important;
    }

    .home-card-title {
      font-weight: 500;
      font-size: 18px;
      text-overflow:ellipsis;
      max-width: 80%;
      overflow:hidden;
      white-space: nowrap;
    }

    .flex-card {
      padding: 10px;
      min-width: 0;
      flex-grow: 0;
      flex-basis: 50%;
      flex-shrink: 1;
    }

    .form-card:hover {
      background: rgba(0,0,0,0.05)
    }

    .form-card .v-list__tile {
      height: auto !important;
    }

    .mobile-news {
      order: 1 !important;
      padding-top: unset !important;
    }

    .mobile-news-expanded {
      order: 1 !important;
      padding-top: unset !important;
    }

    .mobile-news-expanded .news-feed {
      padding: 10px !important;
      background: rgba(0,0,0,0.1) !important;
    }

    .mobile-news-expanded .news-article {
      padding-bottom: 20px;
    }

    .mobile-news .news-feed {
      padding: 10px !important;
      background: rgba(0,0,0,0.1) !important;
    }

    .mobile-news .news-article .v-card {
      box-shadow: unset !important;
    }

    .mobile-primary {
      order: 2 !important;
      margin: 10px;
    }

    .mobile-news-expanded .news-feed {
      max-height: 100vh !important;
    }
    .full-page-preloader {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;
      width: 100%;
      background-color: transparent;
    }
    
    .preloader-text {
      margin-top: 20px;
      font-size: 18px;
      font-weight: 500;
      color: #555;
    }

    .fade-up-enter-active, .fade-up-leave-active {
      transition: opacity 0.5s ease-out, transform 0.5s ease-out;
    }
    .fade-up-enter, .fade-up-leave-to {
      opacity: 0;
      transform: translateY(20px);
    }
</style>

<style>


.mobile-news .news-article .v-card {
  box-shadow: unset !important;
  background: unset;
  padding:0 !important;margin:0 !important;
}

.mobile-news .news-article iframe {
  height: 200px !important;
}

.mobile-news .news-card-text {
  -webkit-line-clamp: 3;
  line-clamp: 3;
}

.mobile-news .news-article:nth-child(n+2) {
  display: none;
}

.mobile-news-expanded .news-article:nth-child(n+2) {
  display: block !important;
}

</style>